// Models
import { Status, States } from '@sift/resift/models/Status';

// ------------------------------------
// Constants
// ------------------------------------
export const CONFIG_FETCH = 'CONFIG_FETCH';
export const CONFIG_FETCH_SUCCESS = 'CONFIG_FETCH_SUCCESS';
export const CONFIG_FETCH_ERROR = 'CONFIG_FETCH_ERROR';

export const FIELD_UPDATE = 'FIELD_UPDATE';
export const FIELD_UPDATE_SUCCESS = 'FIELD_UPDATE_SUCCESS';
export const FIELD_UPDATE_ERROR = 'FIELD_UPDATE_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

/**
 * Get person
 *
 * @param {string} params person Id
 */
export function fetchConfig(configType) {
  return {
    type: CONFIG_FETCH,
    identifier: configType,
    payload: {
      configType,
    },
  };
}

/**
 * update an Entity Field
 *
 * @param {object} params field
 */
export function updateField(entityType, field) {
  return {
    type: FIELD_UPDATE,
    identifier: {
      entityType: entityType,
      fieldId: field.objectKey,
    },
    payload: {
      entityType: entityType,
      field: field,
      data: field,
    },
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CONFIG_FETCH]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
      statuses: {
        ...state.statuses,
        [action.identifier]: new Status(States.LOADING | States.NORMAL),
      },
    };
  },
  [CONFIG_FETCH_SUCCESS]: (state, action) => {
    return {
      ...state,
      [action.identifier]: action.payload.data,
      status: new Status(States.NORMAL),
      statuses: {
        ...state.statuses,
        [action.identifier]: new Status(States.NORMAL),
      },
    };
  },
  [CONFIG_FETCH_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
  [FIELD_UPDATE]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING),
    };
  },
  [FIELD_UPDATE_SUCCESS]: (state, action) => {
    return {
      ...state,
      [action.identifier.entityType]: {
        ...state[action.identifier.entityType],
        fields: {
          ...state[action.identifier.entityType].fields,
          [action.identifier.fieldId]: action.payload.data,
        },
      },
      status: new Status(States.NORMAL),
    };
  },
  [FIELD_UPDATE_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.ERROR),
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  status: new Status(),
  statuses: {
    user: new Status(),
    global: new Status(),
  },
};

export default function ConfigurationReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
